export const BRAND = '#0F9599';
export const BRAND_DARK = '#0F6E56';
export const BRAND_SOFT = '#E1F5EE';
export const TEXT_PRIMARY = '#111827';
export const TEXT_INK = '#1A2B2B';
export const TEXT_SECONDARY = '#6B7280';
export const TEXT_TERTIARY = '#9CA3AF';
export const BG_CARD = '#FFFFFF';
export const BG_HOVER = '#F9FAFB';
export const BORDER = '#E5E7EB';
export const BORDER_LIGHT = '#F0F4F4';
export const DANGER = '#DC2626';
export const SUCCESS_TEXT = '#166534';
export const SUCCESS_SOFT = '#DCFCE7';